import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CEPRepository, CEP_REPOSITORY } from '../repositories/cep.repository';
import { Endereco, RespostaViaCEP } from '../models/endereco.model';

/**
 * Caso de uso para consulta de CEP
 * Implementa a lógica de negócio para consultar endereços por CEP
 */
@Injectable({
  providedIn: 'root'
})
export class ConsultarCEPUseCase {
  
  constructor(@Inject(CEP_REPOSITORY) private cepRepository: CEPRepository) {}

  /**
   * Executa a consulta de CEP
   * @param cep CEP a ser consultado (formato: 8 dígitos)
   * @returns Observable com o endereço encontrado ou erro
   */
  execute(cep: string): Observable<RespostaViaCEP> {
    // Lógica de negócio adicional pode ser adicionada aqui
    // Por exemplo: cache, rate limiting, etc.
    
    return this.cepRepository.consultarPorCEP(cep);
  }

  /**
   * Verifica se o CEP é válido
   * @param cep CEP a ser validado
   * @returns true se o CEP é válido
   */
  validarCEP(cep: string): boolean {
    if (!cep) return false;
    
    // Remove espaços e caracteres especiais
    const cepLimpo = cep.replace(/\D/g, '');
    
    // Verifica se tem exatamente 8 dígitos
    return /^\d{8}$/.test(cepLimpo);
  }

  /**
   * Formata o CEP para exibição
   * @param cep CEP no formato 8 dígitos
   * @returns CEP formatado (ex: "01001-000")
   */
  formatarCEP(cep: string): string {
    if (!this.validarCEP(cep)) return cep;
    
    const cepLimpo = cep.replace(/\D/g, '');
    return cepLimpo.replace(/^(\d{5})(\d{3})$/, '$1-$2');
  }
}
